import styled from 'styled-components';
import Card from '$app/components/vendor/Card';

export const colors = {
  titleBlack: '#201e1e',
  cancelled: 'grey',
  complete: 'grey',
  active: '#3be6b1',
  accepted: '#3be6b1',
  unallocated: '#ffa39e',
  pending: 'gold',
};

export const TableCard = styled(Card)`
  min-height: 200px;
  margin-bottom: 8px;
`;

export const TitleDiv = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: ${colors['titleBlack']};
`;
